.textStyle {
	font-size: 16px;
	vertical-align: middle;
	margin-left: -15px;
}
.gridStyle {
	margin-top: 10px !important;
	text-align: left;
}
.selectBoxStyle {
	margin-top: 1.2em !important;
}
